import { useContext } from "@nuxtjs/composition-api";
function useDomain() {
  const { store } = useContext();
  const domain = store.getters["config/getDomain"];
  return {
    domain
  };
}
var useDomain_default = useDomain;
export {
  useDomain_default as default
};
